import React from "react";
import ReactSignatureCanvas from "react-signature-canvas";

interface DigitalSignatureBoxProps {
  digitalSignature: string | undefined;
  isEditingSignature: boolean;
  sigCanvasRef: React.RefObject<ReactSignatureCanvas | null>;
  touched: {
    digitalSignature?: boolean;
  };
  errors?: {
    digitalSignature?: string;
  };
  onEdit: () => void;
  onSave: () => void;
  onClear: () => void;
  onCancel: () => void;
}

const DigitalSignatureBox: React.FC<DigitalSignatureBoxProps> = ({
  digitalSignature,
  isEditingSignature,
  sigCanvasRef,
  touched,
  errors,
  onEdit,
  onSave,
  onClear,
  onCancel,
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg mb-4">
      <h3 className="text-lg font-semibold mb-4">Digital Signature</h3>
      <div className="border-2 border-gray-300 rounded-lg p-4 bg-white">
        {digitalSignature && !isEditingSignature ? (
          <div className="flex flex-col items-center">
            <img
              src={digitalSignature}
              alt="Digital Signature"
              className="border border-gray-200 rounded"
              style={{ maxWidth: '500px', maxHeight: '200px' }}
            />
            <button
              type="button"
              onClick={onEdit}
              className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Edit Signature
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <div className="flex justify-center">
              <ReactSignatureCanvas
                ref={sigCanvasRef}
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: 'sigCanvas border border-gray-200 rounded',
                }}
              />
            </div>
            <div className="flex gap-2 mt-3">
              <button
                type="button"
                onClick={onClear}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
              >
                Clear
              </button>
              <button
                type="button"
                onClick={onSave}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                Save
              </button>
              {digitalSignature && (
                <button
                  type="button"
                  onClick={onCancel}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      {touched.digitalSignature && errors?.digitalSignature && (
        <p className="text-red-500 text-sm mt-1">{errors.digitalSignature}</p>
      )}
    </div>
  );
};

export default DigitalSignatureBox;

